import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class NutrientsApi {
  createNutrient(payload) {
    return api.post(API_URLS.URL.nutrients.createNutrients, payload);
  }

  updateNutrient(id, payload) {
    return api.put(
      API_URLS.URL.nutrients.updateNutrients?.replace(
        ":id",
        id,
      ),
      payload
    );
  }

  getNutrientsList(payload) {
    return api.post(API_URLS.URL.nutrients.getNutrientsList, payload);
  }

  deleteNutrient(id) {
    return api.delete(
      API_URLS.URL.nutrients.deleteNutrients?.replace(
        ":id",
        id,
      )
    );
  }
}
